import { MenuRouteID } from "../components/header/menu-item/nav-item";

export class RouteConstants {
    public static HOME = { bcRoute: [{ label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] }] };

    public static CHARGE_POINT_OPERATORS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cpo', route: ['operators', { routeID: MenuRouteID.OPERATORS }] }
        ]
    };

    public static ANALYTICS_REVENUE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.revenue', route: ['revenue', { routeID: MenuRouteID.REVENUE }] }
        ]
    };

    public static ANALYTICS_FOOTFALL = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.footFall', route: ['footfall', { routeID: MenuRouteID.FOOTFALL }] }
        ]
    };

    public static ANALYTICS_CHARGEBOX = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.chargeBox', route: ['chargebox', { routeID: MenuRouteID.CHARGEBOX }] }
        ]
    };

    public static ANALYTICS_DEEPDIVE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.deepDive', route: ['deepdive', { routeID: MenuRouteID.DEEPDIVE }] }
        ]
    };

    
    public static STATIONS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.stationList', route: ['stations', { routeID: MenuRouteID.STATIONS }] }
        ]
    };

    public static STATION_DETAILS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.stationList', route: ['stations', { routeID: MenuRouteID.STATIONS }] },
            { label: 'dashboard.stationDetails', route: ['stations/details', { routeID: MenuRouteID.TABS.STATION_DETAILS }] }
        ]
    };

    public static ADD_STATION = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.stationList', route: ['stations', { routeID: MenuRouteID.STATIONS }] },
            { label: 'dashboard.addStation', route: ['add-station', { routeID: MenuRouteID.ADD_STATION }] }
        ]
    }; 
    
    
    public static CHARGING_PROFILE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.chargingProfiles', route: ['charging-profiles', { routeID: MenuRouteID.CHARGING_PROFILE }] }
        ]
    };

    public static CHARGING_TRANSACTION = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.chargingTransactions', route: ['charging-transactions', { routeID: MenuRouteID.CHARGING_TRANSACTION }] }
        ]
    };   
    
    public static MOBILE_USERS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.mobileUsers', route: ['mobile-users', { routeID: MenuRouteID.MOBILE_USERS }] }
        ]
    };
    
    public static WALLETS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.wallet', route: ['wallets', { routeID: MenuRouteID.WALLETS }] }
        ]
    };

    public static WALLETS_ADJUSMENT = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.wallet', route: ['wallets', { routeID: MenuRouteID.WALLETS }] },
            { label: 'transactions.walletAdjustment', route: ['wallets/transactions', { routeID: MenuRouteID.WALLETS }] }
        ]
    };

    public static TRANSACTIONS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.transactions', route: ['transactions', { routeID: MenuRouteID.TRANSACTIONS }] }
        ]
    };

    public static RFID = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.rfidList', route: ['rfid', { routeID: MenuRouteID.RFID }] }
        ]
    };

    public static REFER_FRIEND = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.referFriend', route: ['refer-friend', { routeID: MenuRouteID.REFER_FRIEND }] }
        ]
    };

    public static SERVICE_REQUEST = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.serviceRequest', route: ['service-request', { routeID: MenuRouteID.SERVICE_REQUEST }] }
        ]
    };

    public static INFO = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.infoUpdates', route: ['info', { routeID: MenuRouteID.INFO_UPDATES }] }
        ]
    };

    public static ALERTS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.alerts', route: ['alerts', { routeID: MenuRouteID.ALERTS }] }
        ]
    };

    public static FAQ = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'header.faq', route: ['faq', { routeID: MenuRouteID.PROFILES.FAQ }] }
        ]
    };

    public static TARIFF = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tariff', route: ['tariff', { routeID: MenuRouteID.TARIFF }] }
        ]
    };

    public static TARIFF_MGMT = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tarrifManagement', route: ['tariff-management', { routeID: MenuRouteID.TARIFF_MANAGEMENT }] }
        ]
    };

    public static TARIFF_MGMT_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tarrifManagement', route: ['tariff-management', { routeID: MenuRouteID.TARIFF_MANAGEMENT }] },
            { label: 'tarrif.create.popupTitle', route: ['tariff/create', { routeID: MenuRouteID.TARIFF_MANAGEMENT }] }
        ]
    };

    public static TARIFF_MGMT_EDIT = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tarrifManagement', route: ['tariff-management', { routeID: MenuRouteID.TARIFF_MANAGEMENT }] },
            { label: 'tarrif.create.editpopup', route: ['tariff/create', { routeID: MenuRouteID.TARIFF_MANAGEMENT }] }
        ]
    };

    public static REPORT_RECON = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.reconiliation', route: ['report/reconsillation', { routeID: MenuRouteID.RECONSILLATION }] }
        ]
    };

    public static REPORT_SETTLEMENT = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.settlement', route: ['report/settlement', { routeID: MenuRouteID.SETTLEMENT }] }
        ]
    };

    public static REPORT_CHARGER = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.charger', route: ['report/charger', { routeID: MenuRouteID.CHARGER }] }
        ]
    };

    public static REPORT_SCHEDULE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.schedulereport', route: ['report/schedule', { routeID: MenuRouteID.SCHEDULE }] }
        ]
    };
    
    public static TENANTS_LIST = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tenantList', route: ['tenants', { routeID: MenuRouteID.TENANTS }] }
        ]
    };

    public static TENANTS_ADMIN = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tenantList', route: ['tenants', { routeID: MenuRouteID.TENANTS }] },
            { label: 'dashboard.tenantAdmin', route: ['tenants/tenantAdmins', { routeID: MenuRouteID.TENANTS }] }
        ]
    };

    public static TENANTS_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tenantList', route: ['tenants', { routeID: MenuRouteID.TENANTS }] },
            { label: 'dashboard.tenantOnboard', route: ['tenants/landing', { routeID: MenuRouteID.TENANTS }] }
        ]
    };

    public static TENANTS_UPDATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.tenantList', route: ['tenants', { routeID: MenuRouteID.TENANTS }] },
            { label: 'dashboard.tenantOnboardUpdate', route: ['tenants/landing', { routeID: MenuRouteID.TENANTS }] }
        ]
    };

    public static ROLES = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.roles', route: ['user-management/roles', { routeID: MenuRouteID.ROLES }] }
        ]
    }

    public static ROLES_MAPPING = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.rolesMapping', route: ['user-management/roles/mapping', { routeID: MenuRouteID.ROLES }] }
        ]
    }

    public static USERS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cmsUser', route: ['user-management/users', { routeID: MenuRouteID.CMS_USERS }] }
        ]
    }

    public static USERS_MAPPING = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.usersMapping', route: ['user-management/users/mapping', { routeID: MenuRouteID.CMS_USERS }] }
        ]
    };

    public static GROUPS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.groups', route: ['user-management/groups', { routeID: MenuRouteID.GROUPS }] }
        ]
    }

    public static GROUPS_MAPPING = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.groupsMapping', route: ['user-management/groups/mapping', { routeID: MenuRouteID.GROUPS }] }
        ]
    };

    public static CHARGING_TRANSACTION_OPERATOR = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.chargingTransactions', route: ['charging-transactions', { routeID: MenuRouteID.CHARGING_TRANSACTION }] },
            { label: 'dashboard.cpo', route: ['operators', { routeID: MenuRouteID.OPERATORS }] }
        ]
    }

    public static CHARGING_TRANSACTION_STATION = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.chargingTransactions', route: ['charging-transactions', { routeID: MenuRouteID.CHARGING_TRANSACTION }] },
            { label: 'dashboard.stationDetails', route: ['stations/details', { routeID: MenuRouteID.TABS.STATION_DETAILS }] }
        ]
    };

    public static ALERT_NOTIFICATION_STATION = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.alerts', route: ['alerts', { routeID: MenuRouteID.ALERTS }] },
            { label: 'dashboard.stationDetails', route: ['stations/details', { routeID: MenuRouteID.TABS.STATION_DETAILS }] }
        ]
    };

    public static LIST_OF_STATION_DETAILS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.stationList', route: ['stations', { routeID: MenuRouteID.STATIONS }] },
            { label: 'dashboard.stationDetails', route: ['stations/details', { routeID: MenuRouteID.TABS.STATION_DETAILS }] }
        ]
    };

    public static GROUP_GROUP_MAPPING = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.groups', route: ['user-management/groups', { routeID: MenuRouteID.GROUPS }] },
            { label: 'dashboard.groupsMapping', route: ['user-management/groups/mapping', { routeID: MenuRouteID.GROUPS }] }
        ]
    };

    public static ROLE_ROLE_MAPPING = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.roles', route: ['user-management/roles', { routeID: MenuRouteID.ROLES }] },
            { label: 'dashboard.rolesMapping', route: ['user-management/roles/mapping', { routeID: MenuRouteID.ROLES }] }
        ]
    };

    public static USER_MANAGEMENT_OPERATORS = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cmsUser', route: ['user-management/users', { routeID: MenuRouteID.CMS_USERS }] },
            { label: 'createCpo.details', route: ['operators', { routeID: MenuRouteID.OPERATORS }] }
        ]
    };

    public static CHARGE_POINT_OPERATOR_OPERATOR = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cpo', route: ['operators', { routeID: MenuRouteID.OPERATORS }] },
            { label: 'createCpo.details', route: ['operators', { routeID: MenuRouteID.OPERATORS }] }
        ]
    };

    public static CHARGE_POINT_OPERATOR_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cpo', route: ['operators', { routeID: MenuRouteID.OPERATORS }] },
            { label: 'gst.operator_onboarding', route: ['operators', { routeID: MenuRouteID.OPERATORS }] }
        ]
    };

    public static CHARGE_POINT_OPERATOR_UPDATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cpo', route: ['operators', { routeID: MenuRouteID.OPERATORS }] },
            { label: 'gst.operator_onboarding_update', route: ['operators', { routeID: MenuRouteID.OPERATORS }] }
        ]
    };

    public static SERVICE_REQUEST_TICKET_MESSAGE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.serviceRequest', route: ['service-request', { routeID: MenuRouteID.SERVICE_REQUEST }] },
            { label: 'dashboard.messageRequest', route: ['service-request-message', { routeID: MenuRouteID.SERVICE_REQUEST }] }
        ]
    };

    public static MOBILE_USERS_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.mobileUsers', route: ['mobile-users', { routeID: MenuRouteID.MOBILE_USERS }] },
            { label: 'dashboard.create', route: ['mobile-users/create', { routeID: MenuRouteID.MOBILE_USERS }] },
        ]
    };

    public static MOBILE_USERS_EDIT = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.mobileUsers', route: ['mobile-users', { routeID: MenuRouteID.MOBILE_USERS }] },
            { label: 'dashboard.edit', route: ['mobile-users/create', { routeID: MenuRouteID.MOBILE_USERS }] },
        ]
    };

    public static RFID_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.rfidList', route: ['rfid', { routeID: MenuRouteID.RFID }] },
            { label: 'dashboard.create', route: ['rfid/create', { routeID: MenuRouteID.RFID }] }
        ]
    };

    public static RFID_EDIT = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.rfidList', route: ['rfid', { routeID: MenuRouteID.RFID }] },
            { label: 'rfid.editTitle', route: ['rfid/edit-assign', { routeID: MenuRouteID.RFID }] }
        ]
    };

    public static RFID_ASSIGN = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.rfidList', route: ['rfid', { routeID: MenuRouteID.RFID }] },
            { label: 'rfid.assignTitle', route: ['rfid/assign', { routeID: MenuRouteID.RFID }] }
        ]
    };

    public static CHARGING_PROFILE_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.chargingProfiles', route: ['charging-profiles', { routeID: MenuRouteID.CHARGING_PROFILE }] },
            { label: 'dashboard.create', route: ['charging-profiles/create', { routeID: MenuRouteID.CHARGING_PROFILE }] }
        ]
    };

    public static SERVICE_REQUEST_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.serviceRequest', route: ['service-request', { routeID: MenuRouteID.SERVICE_REQUEST }] },
            { label: 'dashboard.create', route: ['service-request/new-request', { routeID: MenuRouteID.SERVICE_REQUEST }] }
        ]
    };

    public static USER_MANAGEMENT_CREATE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cmsUser', route: ['user-management/users', { routeID: MenuRouteID.CMS_USERS }] },
            { label: 'dashboard.create', route: ['operators/create', { routeID: MenuRouteID.CMS_USERS }] }
        ]
    }

    public static MY_PROFILE = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'header.myProfile', route: ['operators/create', { routeID: MenuRouteID.OPERATORS }] }
        ]
    };
    
    public static OPERATOR_INFO = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.stationList', route: ['stations', { routeID: MenuRouteID.STATIONS }] },
            { label: 'createCpo.titleName', route: ['operators', { routeID: MenuRouteID.OPERATORS }] }
        ]
    };

    public static USER_MANAGEMENT_EDIT_OPERATOR = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.cmsUser', route: ['user-management/users', { routeID: MenuRouteID.CMS_USERS }] },
            { label: 'createCpo.editTitle', route: ['operators/create', { routeID: MenuRouteID.CMS_USERS }] }
        ]
    };
    
    public static STATION_DETAILS_MAP = {
        bcRoute: [
            { label: 'dashboard.dashboard', route: ['home', { routeID: MenuRouteID.HOME }] },
            { label: 'dashboard.stationDetails', route: ['stations/details', { routeID: MenuRouteID.TABS.STATION_DETAILS }] }
        ]
    };

}